import type { SVGProps } from 'react';
import { twMerge } from 'tailwind-merge';
import { ARROW_ICON_DIRECTIONS, type ArrowIconDirection } from './types/arrow-icon-direction';

type ArrowIconProps = SVGProps<SVGSVGElement> & {
  direction: ArrowIconDirection
};

export const ArrowIcon: React.FC<ArrowIconProps> = ({ direction, className: externalClassName, ...props }) => {
  const rotateClassName = getRotateClassName(direction);
  const className = twMerge(externalClassName, rotateClassName);

  return (
    <svg
      width="12"
      height="7"
      viewBox="0 0 12 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M10.7305 1.21484L6.03857 5.90723L1.34521 1.21484"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

function getRotateClassName(direction: ArrowIconDirection): string {
  switch (direction) {
    case ARROW_ICON_DIRECTIONS.UP:
      return 'rotate-180';    
    case ARROW_ICON_DIRECTIONS.LEFT:
      return 'rotate-90';
    case ARROW_ICON_DIRECTIONS.RIGHT:
      return '-rotate-90';
    case ARROW_ICON_DIRECTIONS.DOWN:
    default:
      return '';
  }
}